<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-select
          class="w-full"
          label="Selecione o Tipo de Endosso"
          v-model="endorsementTypeId"
          data-testId="endorsement-type-select"
        >
          <vs-select-item
            :key="index"
            :value="item.id"
            :text="item.type"
            v-for="(item, index) in endorsementTypes"
          />
        </vs-select>
      </div>
    </div>
    <div class="row mt-10 text-right">
      <div class="">
        <vs-button
          color="success"
          class="mb-2"
          @click="createEndorsement()"
          data-testId="endorsement-popup-create-button"
          >Fazer Endosso
        </vs-button>
      </div>
    </div>
  </div>
</template>
<script>
import quotationApiService from '../../services/quotation-api';
import functions from '../../utils/functions';

export default {
  props: ['dadosProposta'],
  watch: {},
  data() {
    return {
      endorsementTypeId: null,
      endorsementTypes: [],
    };
  },
  mounted() {
    this.getEndorsementTypes();
  },
  computed: {},
  methods: {
    async getEndorsementTypes() {
      this.endorsementTypes = await quotationApiService.getEndorsementTypes();
    },
    async createEndorsement() {
      /*const endosement = {
        endorsementTypeId: this.endorsementTypeId,
        insuranceId: this.dadosProposta.idApolice,
      };

      await quotationApiService.createEndorsement(
        this.dadosProposta.idProposta,
        endosement,
      );*/
      let linkRelativo = window.location.origin;
      window.parent.location.href = `${linkRelativo.replace(
        'app.',
        'adm.',
      )}/auto/proposta/${this.dadosProposta.idProposta}`;
    },
  },
};
</script>
<style scoped></style>
